import { addPolygonRange, removePolygonRange } from 'Pods/SearchPage/Store/actions/polygon'
import {
  setAnimated, setPbr, setRigged, setGameReady, setWithRenders,
} from 'Pods/SearchPage/Store/actions/threeDOnly'
import { setThreeDPrintVerified, setWithMakes } from 'Pods/SearchPage/Store/actions/threeDPrintOnly'
import { POLYGON_RANGE } from 'Pods/SearchPage/Store/constants'

const handleLowPolyChange = (isOn) => {
  if (isOn) {
    addPolygonRange(POLYGON_RANGE.LOW_POLY)
  } else {
    removePolygonRange(POLYGON_RANGE.LOW_POLY)
  }
}

export const FEATURES = [
  {
    value: 'animated',
    labelKey: 'technical_attributes.animated',
    select: state => state.animated,
    onChange: setAnimated,
  },
  {
    value: 'pbr',
    labelKey: 'technical_attributes.pbr',
    select: state => state.pbr,
    onChange: setPbr,
  },
  {
    value: 'rigged',
    labelKey: 'technical_attributes.rigged',
    select: state => state.rigged,
    onChange: setRigged,
  },
  {
    value: 'low_poly',
    labelKey: 'technical_attributes.low_poly',
    select: state => state.polygonRanges.includes(POLYGON_RANGE.LOW_POLY),
    onChange: handleLowPolyChange,
  },
  {
    value: 'game_ready',
    labelKey: 'features.game_ready',
    select: state => state.gameReady,
    onChange: setGameReady,
  },
  {
    value: 'with_renders',
    labelKey: 'features.with_renders',
    select: state => state.withRenders,
    onChange: setWithRenders,
  },
]

// The 3D-print counterpart of FEATURES: the same chips PrintAttributes expands at lg+.
export const PRINT_FEATURES = [
  {
    value: 'with_makes',
    labelKey: 'print_attributes.with_makes',
    select: state => state.withMakes,
    onChange: setWithMakes,
  },
  {
    value: 'three_d_print_verified',
    labelKey: 'print_attributes.three_d_print_verified',
    select: state => state.threeDPrintVerified,
    onChange: setThreeDPrintVerified,
  },
]

export const DEFAULT_LIMIT = 4
